import { createContext, useContext } from 'react';

export const PackageContext = createContext();

export function usePackageContext() {
    return useContext(PackageContext);
}
